import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ClubDataRow from '../components/ClubDataRow';
import Header from "../../Units/Header";
import { useParams } from 'react-router-dom';
import {openDialog} from "../../../store/actionCreators/dialog";
import "../../../assets/stylesheets/Union/UnionClubData.scss";

const timezone = "America / Chicago / UTC - 05:00";

const data = [
    {
        _id: 1334,
        username: 'Test 1',
        avatar: {
            avatarId: null,
            count: null,
            imageUrl: "https://stagingimages.pokerplaza.com/uploads/4452_1584621091989.png",
        },
        founder: 1,
        stats: {
            overall: 65800,
            lastWeek: 5800,
            thisWeek: -800, 
        },
    },
    {
        _id: 1335,
        username: 'Test 2',
        avatar: {
            avatarId: null,
            count: null,
            imageUrl: "https://stagingimages.pokerplaza.com/uploads/4452_1584621091989.png",
        },
        founder: 0,
        stats: {
            overall: 65800,
            lastWeek: 5800,
            thisWeek: -800, 
        },
    },
    {
        _id: 1336,
        username: 'Test 3',
        avatar: {
            avatarId: null,
            count: null,
            imageUrl: "https://stagingimages.pokerplaza.com/uploads/4452_1584621091989.png",
        },
        founder: 0,
        stats: {
            overall: 65800,
            lastWeek: 5800,
            thisWeek: -800, 
        },
    },
];

const renderRow = (data) => (
    <ClubDataRow data={data} avatar={data.avatar} />
);

const ClubData = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { id: unionId } = useParams();

    const onExcel = useCallback(() => {
        dispatch(openDialog('exportData', {
            realDialog: true,
            fixed: true,
            grayHeader: true,
            noPaddings: true,
            noFooter: true,
            headerIcon: 'excel',
            title: 'export',
        }));
    }, [dispatch]);

    return (
        <div className="clubDataPage unionPage">
            <Header
                title={'unionDataTitle'}
                backTo={`/union/${unionId}`}
                className="dialogHeader--gray"
                onExcel={onExcel}
                helpTo={`/union/${unionId}/data/help`}
            />
            <div className="timezoneInfo">
                <p className="timezoneInfoText">{t('dataIsRecordedBasedOnUnionHeadData')}</p>
                <p className="timezoneInfoText">{timezone}</p>
            </div>
            <ul className="clubList">
                {data.map(renderRow)}
            </ul>
        </div>
    );
}

export default ClubData;